import React from 'react';
import { Input } from 'reactstrap';
import { Control, Controller, FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

import 'react-datepicker/dist/react-datepicker.css';
import './FormComponents.css';

export interface ICustomFileUploadProps<T extends FieldValues> {
  control: Control<T, object>;
  fieldName: FieldPath<T>;
  placeholder?: string;
  rules?: Omit<
    RegisterOptions<T, FieldPath<T>>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  className?: string;
  readonly?: boolean;
}

export function ControlledFileUploadInput<T extends FieldValues>({
  fieldName,
  control,
  placeholder,
  rules,
  className,
}: ICustomFileUploadProps<T>) {
  return (
    <Controller
      name={fieldName}
      control={control}
      rules={rules || {}}
      render={({ field, fieldState, formState }) => {
        const isValid: boolean =
          !fieldState.invalid && (fieldState.isTouched || formState.isSubmitted);
        const isInvalid: boolean =
          fieldState.invalid && (fieldState.isTouched || formState.isSubmitted);
        var items = (field.value as File[]) || [];

        return (
          <Input
            className={className || ''}
            control={control}
            type="file"
            multiple={true}
            valid={isValid}
            invalid={isInvalid}
            onChange={(e) => {
              field.onChange([...items, ...Array.from(e.currentTarget.files || [])]);
            }}
            placeholder={placeholder || ''}
            accept=".pdf, .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .csv"
          />
        );
      }}
    />
  );
}
